
import * as C from '../constants/merchantTypes';

/**
 * refer fetchResellerAgreement reducer responsible for reseller agreement
 * @param  {object} state  initial state
 * @param  {object} action redux action object
 * @return {object}        redux store state
 */

 const initialState = { data: { incentives: [], 
      total_count: 0,
      per_page: 10,
      next_page: null,
      prev_page: null,
      current_page: 1,
      first_page: true,
      last_page: false 
    }
  }

export default function fetchResellerAgreement(state = initialState, action) {
  switch (action.type) {
    case C.FETCH_RESELLER_AGREEMENT_INITIATED:
      return {
        ...state, fetching: true, success: false, error: null,
      };
    case C.FETCH_RESELLER_AGREEMENT_SUCCESS:
      return {
        ...state, agreement: action.payload, fetching: false, success: true, error: null,
      };
    case C.FETCH_RESELLER_AGREEMENT_FAILURE:
      return {
        ...state, fetching: false, success: false, error: action.payload,
      };
    case C.FETCH_RESELLER_INCENTIVE_SUCCESS:
      return {
        ...state, fetching: false, success: true, data: {...action.payload }
      };
    case C.FETCH_RESELLER_INCENTIVE_FAILURE:
      return {
        ...state, fetching: false, success: false, error: action.payload
      };
    default:
      return state;
  }
}

